export default __webpack_public_path__ + "static/layout-anatomy-dark-76959a4670993bc6afee594ad3c29cda60c0a53399c1ffada5a0d4f8ef64b5ea.png";